import React from 'react';
import { Box, SxProps } from '@mui/material';
import { Button } from 'system/atoms';
import { useConfirmationModal } from 'services/modals/hooks';

const container: SxProps = {
  display: 'flex',
  gap: 2
};

type Props = {
  handleNext: () => void;
  disabled?: boolean;
  nextText?: string;
  isError?: boolean;
  errorMessage?: string;
  errorTitle?: string;
  isLoading?: boolean;
};

export const NextButton: React.FC<Props> = ({
  handleNext,
  disabled,
  nextText = 'Next step',
  isError,
  errorMessage,
  errorTitle,
  isLoading
}) => {
  const { showModal } = useConfirmationModal();

  const handleClick = () => {
    if (isError) {
      showModal({
        title: errorTitle || 'Error',
        message: errorMessage
      });
      return;
    }
    handleNext();
  };

  return (
    <Box sx={container}>
      <Button
        onClick={handleClick}
        variant="primary"
        disabled={disabled || isLoading}
        loading={isLoading}
      >
        {nextText}
      </Button>
    </Box>
  );
};
